import React from 'react';
import {useRegFormsContext} from '../RegFormsContext';
import {FormattedMessage} from "react-intl";
import WarningNote from "../WarningNote";

const WarningNoteContainer = () => {
  const {form101FileStatus} = useRegFormsContext();

  return (
    <>
      {!form101FileStatus.exists && (
        <WarningNote
          label={
            <FormattedMessage
              id={'regForms-note-form-101-label'}
              defaultMessage={'Update form 101'}
            />
          }
          text={
            <FormattedMessage
              id={'regForms-note-form-101-text'}
              defaultMessage={"Every year form 101 must be filled out again, it's time to do it again."}
            />
          }
        />
      )
      }
    </>
  );
};

export default WarningNoteContainer;
